import GridPattern from "@/components/grid-pattern";

export default function Background() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-stone-950"
    >
      <GridPattern
        width={44}
        height={44}
        x={-1}
        y={-1}
        className="stroke-emerald-400/[0.09] [mask-image:radial-gradient(ellipse_at_top,white,rgba(255,255,255,0.72),transparent_88%)]"
      />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(16,185,129,0.05),transparent_38%)]" />
      <div className="absolute inset-0 bg-linear-to-b from-stone-950/0 via-stone-950/28 to-stone-950/82" />
    </div>
  );
}
